module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100 noselect"
  }, [(_vm.aucunUtilisateurAssocie) ? _c('div', {
    staticClass: "mess h-100 w-100 p-0 m-0"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "data-testid": "accessError-title"
    }
  }, [_vm._v("Vous n'êtes pas autorisé à vous connecter.")]), _vm._v(" "), _c('div', {
    attrs: {
      "data-testid": "accessError-message"
    }
  }, [_vm._v("Rapprochez-vous de votre administrateur afin qu'il associe votre compte SSO à votre profil salarié pour vous donner les accès.")])]) : _c('div', {
    staticClass: "section-situation-absences h-100"
  }, [_c('div', {
    staticClass: "body-documents mb-3",
    class: _vm.estValideurExterne ? (_vm.anyTeam ? 'd-flex' : 'd-none') : ''
  }, [_c('div', {
    staticClass: "card-salarie left-panel"
  }, [_c('situation-des-absences', {
    ref: "SituationDesAbsencesComponent",
    class: {
      'd-none': !_vm.dataReady
    },
    attrs: {
      "isModeManager": _vm.isModeManager
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-salarie right-panel",
    class: {
      paieEnable: _vm.paieEnable, 'manager': _vm.isModeManager, 'salarie': !_vm.isModeManager, 'paieDisable': !_vm.paieEnable
    },
    staticStyle: {
      "margin-left": "14px"
    }
  }, [_c('liste-des-demandes', {
    ref: "ListeDesDemandesComponent",
    class: (_vm.dataReady) ? '' : 'd-none',
    attrs: {
      "isModeManager": _vm.isModeManager,
      "modalChangerEtatAbsence": _vm.modalChangerEtatAbsence
    },
    on: {
      "afficherModalSupprimerAbsence": _vm.afficherModalSupprimerAbsence,
      "afficherModalAjouterAbsence": _vm.afficherModalAjouterAbsence,
      "afficherModalValiderAbsence": _vm.afficherModalValiderAbsence,
      "afficherModalDetailAbsence": _vm.afficherModalDetailAbsence,
      "afficherModalChangerEtatAbsence": _vm.afficherModalChangerEtatAbsence,
      "changerEtatAbsenceOk": _vm.changerEtatAbsenceOk,
      "enregistrerAbsenceOk": _vm.enregistrerAbsenceOk
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body-calendar",
    class: _vm.estValideurExterne ? (_vm.anyTeam ? 'demi' : 'full') : 'demi'
  }, [(!_vm.loadCalendar) ? _c('calendrier-component', {
    ref: "calendrierComponent",
    class: {
      'd-none': !_vm.dataReady
    },
    attrs: {
      "typeCalendrier": _vm.currentType
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('modal-detail-absence', {
    ref: "modalDetailAbsence"
  }), _vm._v(" "), _c('modal-ajouter-absence', {
    ref: "modalAjouterAbsence",
    attrs: {
      "idModal": "modalGestionAjouterAbsence",
      "isActionSalarie": true
    },
    on: {
      "enregistrerAbsenceOk": _vm.enregistrerAbsenceOk
    }
  }), _vm._v(" "), _c('modal-changer-etat-absence', {
    ref: "modalChangerEtatAbsence",
    on: {
      "changerEtatAbsenceOk": _vm.changerEtatAbsenceOk
    }
  }), _vm._v(" "), (!_vm.dataReady) ? _c('loader') : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon mb-3",
    attrs: {
      "data-testid": "accessError-icon"
    }
  }, [_c('span', {
    staticClass: "fas fa-exclamation-triangle fa-3x"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-317323f8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsences/gestionDesAbsences.vue.html
// module id = FK5M
// module chunks = 2